import { MetalLeaseDetailView } from "@/modules/metal/MetalLeaseDetailView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/_main/metal/lease/$location/$uuid/")({
    component: Component,
});

function Component() {
    const { uuid, location } = Route.useParams();
    return <MetalLeaseDetailView key={uuid} bareId={uuid} location={location} />;
}
